import { App } from "@common/models";

export interface AppState {
  app: App | undefined;
  loading: boolean;
}

export enum AppContextActionType {
  SET_APP = "SET_APPS",
  SET_LOADING = "SET_LOADING",
}

export interface SetApp {
  type: AppContextActionType.SET_APP;
  payload: App;
}

export interface SetLoading {
  type: AppContextActionType.SET_LOADING;
  payload: boolean;
}

export type AppContextAction = SetApp | SetLoading;
